module.exports = __webpack_public_path__ + "img/2019_s_p_s_mu.be010562.jpg";